import axios from 'axios';

// servidor en Node.js
const endpointUrl = process.env.REACT_APP_NEFRO_API_URL;

// peticiones de aplicación
const request = (endpoint, obj, method = 'GET') => {
    const url = `${endpointUrl}/${endpoint}`;
    if (method === 'GET') {
        return fetch(url, { method });
    } else {
        return fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(obj)
        });
    }
};

// petición restringida (sólo administradores)
const protectedReq = (endpoint, obj, method = 'GET') => {
    const url = `${endpointUrl}/${endpoint}`;
    // token guardado
    const token = localStorage.getItem('token') || '';
    if (method === 'GET') {
        return fetch(url, {
            method,
            headers: {
                'x-token': token
            }
        });
    } else {
        return fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json',
                'x-token': token
            },
            body: JSON.stringify(obj)
        });
    }
};

const api = axios.create({ baseURL: endpointUrl });
api.interceptors.request.use((config) => {
    // previo a petición
    const token = localStorage.getItem('token');
    if (token)
        config.headers['x-token'] = token;
    
    return config;
});

const apiRequest = async (endpoint, method = 'GET', data = null) => {
    try {
        const response = await api({
            url: endpoint,
            method: method.toUpperCase(),
            data: data, // Aquí puede ir un objeto {} o un FormData
        });
        
        return response.data;
    } catch (error) {
        // Aquí puedes conectar el handleApiError que hicimos antes
        throw error;
    }
};

const axiosRequest = async (path, method = 'GET', formData) => {
    try {
        const url = `${endpointUrl}${path}`;
        // token guardado
        const token = localStorage.getItem('token') || '';

        const config = {
            method,
            url,
            headers: { 'x-token': token },
            data: formData 
        };

        const { data } = await axios(config);
        return data;
    } catch (err) {
        let msg = 'axios-err';
        if (err.response)
            msg = err.response.data?.msg || 'axios-err';
        else if (err.request)
            msg = 'server-down';
        return { status: false, msg };
    };
};

export {
    request,
    protectedReq,
    axiosRequest
};